// extracted by mini-css-extract-plugin
export default {"layout":"app_layout__y72pn","main":"app_main__pQDPN","noNav":"app_noNav__kFID4","nav":"app_nav__SDFyr"};